import { PersonalSetting } from '@ardoq/api-types';
import { dispatchAction } from '@ardoq/rxbeach';
import { updatePersonalSetting } from 'streams/currentUser/actions';
import { getLoadedPersonalSetting } from 'streams/currentUser/getLoadedPersonalSetting';

export const DontShowAgain = {
  APPLY_MERGE_INSTANTLY_DIALOG:
    PersonalSetting.DONT_SHOW_AGAIN_APPLY_MERGE_INSTANTLY_DIALOG,
  BRANCH_OFF_POINT_NOT_UPDATED_ALERT:
    PersonalSetting.DONT_SHOW_AGAIN_BRANCH_OFF_POINT_NOT_UPDATED_ALERT,
  APPLY_ENTITY_MERGE: PersonalSetting.DONT_SHOW_AGAIN_APPLY_ENTITY_MERGE,
  WORKSPACE_MODE_SLIDES_END_INFO:
    PersonalSetting.DONT_SHOW_AGAIN_WORKSPACE_MODE_SLIDES_END_INFO,
} as const;

export type DontShowAgain = (typeof DontShowAgain)[keyof typeof DontShowAgain];

export const getDontShowAgainSetting = async (
  settingKey: DontShowAgain
): Promise<boolean> => {
  if (window.STORYBOOK_ENV) return false;
  return (await getLoadedPersonalSetting(settingKey)) ?? false;
};

export const setDontShowAgainSetting = (
  settingKey: DontShowAgain,
  settingValue: boolean
): void =>
  dispatchAction(
    updatePersonalSetting({
      personalSetting: settingKey,
      newValue: settingValue,
    })
  );
